<!-- Modal Header with standard actions -->
<div class="modal-header">
  <h3 class="modal-title">{{ modalTitle }}</h3>
  <div class="header-actions">
    <i class="fa" 
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}" 
       style="margin-right: 10px; cursor: pointer;" 
       (click)="minimise = !minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- Loading state -->
@if (showFormLoader) {
<div class="modal-body" [hidden]="minimise">
  <div class="formLoader">
    <div style="text-align: center">
      <i class="fa fa-spinner fa-spin gt-refresh"></i>
    </div>
  </div>
</div>
}

<!-- Modal Body -->
@if (!showFormLoader) {
<div class="modal-body" [hidden]="minimise">
  <div class="panel panel-default">
    <div class="panel-heading">
      <h4><b>Reference Table Details:</b></h4>
    </div>
    <div class="panel-body">
      <!-- Row 1: Reference Name, Reference Code, Reference Value -->
      <div class="row">
        <div class="col-md-4">
          <div class="form-group">
            <label for="table-name"><b>Reference Name<sup>*</sup>:</b></label>
            <input
              type="text"
              class="form-control"
              id="table-name"
              name="table-name"
              [(ngModel)]="referenceTableEntity.TABLE_NAME"
              placeholder="Select Reference Name"
              [readonly]="isEdit"
              [class.is-invalid]="referenceTableEntity.TABLE_NAME_NOT_VALID && !referenceTableEntity.TABLE_NAME"
            />
            @if (referenceTableEntity.TABLE_NAME_NOT_VALID && !referenceTableEntity.TABLE_NAME) {
<small
              class="text-danger"
             
            >
              Please provide Reference Name
            </small>
}
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <label for="ref-code"><b>Reference Code<sup>*</sup>:</b></label>
            <input
              type="text"
              class="form-control"
              id="ref-code"
              name="ref-code"
              [(ngModel)]="referenceTableEntity.REF_CODE"
              placeholder="Select Reference Code"
              [readonly]="isEdit"
              [class.is-invalid]="referenceTableEntity.REF_CODE_NOT_VALID && !referenceTableEntity.REF_CODE"
            />
            @if (referenceTableEntity.REF_CODE_NOT_VALID && !referenceTableEntity.REF_CODE) {
<small
              class="text-danger"
             
            >
              Please provide Reference Code
            </small>
}
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <label for="ref-value"><b>Reference Value<sup>*</sup>:</b></label>
            <input
              type="text"
              class="form-control"
              id="ref-value"
              name="ref-value"
              [(ngModel)]="referenceTableEntity.REF_VALUE"
              placeholder="Select Reference Value"
              [class.is-invalid]="referenceTableEntity.REF_VALUE_NOT_VALID && !referenceTableEntity.REF_VALUE"
            />
            @if (referenceTableEntity.REF_VALUE_NOT_VALID && !referenceTableEntity.REF_VALUE) {
<small
              class="text-danger"
             
            >
              Please provide Reference Value
            </small>
}
          </div>
        </div>
      </div>
      
      <!-- Row 2: From Year, To Year -->
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label for="from-tax-year"><b>From Year<sup>*</sup>:</b></label>
            <div class="input-group">
              <input type="text" 
                     class="form-control" 
                     id="from-tax-year" 
                     [value]="fromTaxYear || ''"
                     placeholder="YYYY"
                     readonly/>
              <span class="input-group-addon" 
                    (click)="openFromYearPicker()"
                    style="cursor: pointer;">
                <i class="fa fa-calendar"></i>
              </span>
            </div>
            
            <!-- From Year Picker Popup -->
            <gtw-year-picker-popup
              [selectedYear]="fromTaxYear"
              [showPopup]="showFromYearPicker"
              [minYear]="1900"
              [maxYear]="9999"
              [triggerElementId]="'from-tax-year'"
              (yearSelected)="onFromYearSelected($event)"
              (popupClosed)="closeFromYearPicker()">
            </gtw-year-picker-popup>
            
            @if (referenceTableEntity.FROM_TAX_YEAR_NOT_VALID && !referenceTableEntity.FROM_TAX_YEAR) {
<small class="text-danger" 
                  >
              Please provide From Year
            </small>
}
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label for="to-tax-year"><b>To Year<sup>*</sup>:</b></label>
            <div class="input-group">
              <input type="text" 
                     class="form-control" 
                     id="to-tax-year" 
                     [value]="toTaxYear || ''"
                     placeholder="YYYY"
                     readonly/>
              <span class="input-group-addon" 
                    (click)="openToYearPicker()"
                    style="cursor: pointer;">
                <i class="fa fa-calendar"></i>
              </span>
            </div>
            
            <!-- To Year Picker Popup -->
            <gtw-year-picker-popup
              [selectedYear]="toTaxYear"
              [showPopup]="showToYearPicker"
              [minYear]="1900"
              [maxYear]="9999"
              [triggerElementId]="'to-tax-year'"
              (yearSelected)="onToYearSelected($event)"
              (popupClosed)="closeToYearPicker()">
            </gtw-year-picker-popup>
            
            @if (referenceTableEntity.TO_TAX_YEAR_NOT_VALID && !referenceTableEntity.TO_TAX_YEAR) {
<small class="text-danger" 
                  >
              Please provide To Year
            </small>
}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
}

<!-- Footer with standardized buttons -->
<div class="modal-footer">
  <button
    class="save-button"
    type="button"
    [disabled]="isSaveClicked"
    (click)="save()"
  >
    @if (isSavingUpdate) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}
    @if (!isEdit) {
<span>Create</span>
}
    @if (isEdit) {
<span>Update</span>
}
  </button>

  <button class="reset-button" type="button" (click)="reset()">Reset</button>

  <button class="cancel-button" type="button" (click)="cancel()">Cancel</button>

  @if (isEdit) {
<button
   
    class="delete-button"
    type="button"
    [disabled]="isSaveClicked"
    (click)="delete()"
  >
    @if (isDeleting) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}
    Delete
  </button>
}
</div>
